/**
 * @arriba.digital/contracts
 *
 * Single source of truth for the HTTP surface shared by `apps/api` and
 * `apps/web`: zod validation schemas, inferred TypeScript types, the
 * RBAC matrix, locale list and the canonical route table.
 */
import { installZodErrorMap } from './error-map';

export * from './common';
export * from './country';
export * from './fiscal';
export * from './password';
export * from './auth';
export * from './tenancy';
export * from './catalog';
export * from './warehouse';
export * from './stock';
export * from './documents';
export * from './counterparty';
export * from './dashboard';
export * from './settings';
export * from './routes';
export * from './error-map';

// Applied on import so that any consumer (API or browser) validates with
// i18n keys rather than zod's English defaults.
installZodErrorMap();
